import { IButtonStyles } from '@fluentui/react';
import { concatStyleSets, IStyle, ITheme } from '@fluentui/react/lib/Styling';
import { memoizeFunction } from '@fluentui/react/lib/Utilities';

import { AppGalleryStyles, getAppGalleryStyles } from '@1js/acui-gallery';
import { isThemingEnabled } from '@1js/acui-theme';

const galleryItemWidth = 61;
const galleryBorderWidth = 4;
const galleryPadding = 2;
export const galleryButtonWidth = galleryItemWidth + galleryBorderWidth * 2 + galleryPadding * 2;

const characterGalleryButtonInExpandedStyles = (theme: ITheme): IButtonStyles => {
  return {
    root: {
      height: 75,
      width: galleryItemWidth,
      padding: galleryPadding,
      fontSize: 12,
      color: isThemingEnabled() ? theme.palette.neutralPrimary : '#333333',
      boxSizing: 'content-box',
      borderWidth: galleryBorderWidth,
    },
  };
};

const getCustomizedCharacterCodeGalleryStyles = memoizeFunction(
  (theme: ITheme, customStyles?: Partial<AppGalleryStyles>): Partial<AppGalleryStyles> => {
    return {
      galleryButtonInExpanded: concatStyleSets(
        characterGalleryButtonInExpandedStyles(theme),
        customStyles && customStyles.galleryButtonInExpanded
      ),
    };
  }
);

export const pageNumberPageStyles = (theme: ITheme): IStyle => {
  const borderColor = isThemingEnabled() ? theme.palette.neutralSecondaryAlt : '#969696';
  return {
    height: '100%',
    width: '100%',
    position: 'relative',
    border: `1px solid ${borderColor}`,
    boxSizing: 'border-box',
  };
};

export const getPageNumberGalleryStyles = memoizeFunction(
  (theme: ITheme, customStyles?: Partial<AppGalleryStyles>): AppGalleryStyles => {
    return getAppGalleryStyles(theme, getCustomizedCharacterCodeGalleryStyles(theme, customStyles));
  }
);

export const getPageNumberPositionStyles = (index: number): IStyle => {
  let alignment;
  switch (index % 3) {
    case 0: {
      alignment = { textAlign: 'left', margin: '3px 6px' };
      break;
    }
    case 1: {
      alignment = { textAlign: 'center', margin: '3px 0px' };
      break;
    }
    case 2: {
      alignment = { textAlign: 'right', margin: '3px -6px' };
      break;
    }
  }

  const placement = index < 3 ? { top: '0' } : { bottom: '0' };

  return {
    ...alignment,
    ...placement,
    position: 'absolute',
    width: '100%',
  };
};
